<template>
  <div>
    <section class="app-main">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </section>
    <van-tabbar route active-color="#FF6B31" inactive-color="#999">
      <van-tabbar-item to="/home" icon="wap-home-o">首页</van-tabbar-item>
      <van-tabbar-item to="/template" icon="add-o" v-if="isTeacher || isShopowner || isDistributor">创建活动</van-tabbar-item>
      <van-tabbar-item to="/scan" icon="scan" v-if="isShopowner || isGuide || isDistributor">扫一扫</van-tabbar-item>
      <van-tabbar-item to="/my" icon="user-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Layout',
  computed: {
    key() {
      return this.$route.path
    },
    ...mapGetters([
      'isTeacher',
      'isDistributor',
      'isShopowner',
      'isGuide'
    ])
  },
  data() {
    return {
      cachedViews: []
    }
  }
}
</script>

<style lang="stylus" scoped>
.app-main
  box-sizing: border-box
  max-height calc(100vh - 50px)
  overflow: auto
  color #606266
  &::-webkit-scrollbar
    display none
</style>